export const RESOURCE_KINDS = {
  VEHICLE: 'vehicle',
  EQUIPMENT: 'equipment',
  TOOL: 'tool',
};

export const RESOURCE_KIND_OPTIONS = [
  { value: 'vehicle', label: 'Bus' },
  { value: 'equipment', label: 'Materieel' },
  { value: 'tool', label: 'Gereedschap' },
];

export const RESOURCE_STATUS_OPTIONS = [
  { value: 'available', label: 'Beschikbaar' },
  { value: 'maintenance', label: 'In onderhoud' },
  { value: 'lost', label: 'Kwijt / defect' },
  { value: 'retired', label: 'Afgevoerd' },
];

export const RESOURCE_STATUS_VARIANTS = {
  available: 'success',
  maintenance: 'warning',
  lost: 'danger',
  retired: 'default',
};

export const REQUIREMENT_STATUS_OPTIONS = [
  { value: 'required', label: 'Nodig' },
  { value: 'reserved', label: 'Gereserveerd' },
  { value: 'rented', label: 'Gehuurd' },
  { value: 'on_site', label: 'Op locatie' },
  { value: 'returned', label: 'Retour' },
];

export const REQUIREMENT_STATUS_VARIANTS = {
  required: 'default',
  reserved: 'info',
  rented: 'primary',
  on_site: 'success',
  returned: 'default',
};

export const REQUIREMENT_TRANSITIONS = {
  required: ['reserved', 'rented'],
  reserved: ['required', 'rented', 'on_site'],
  rented: ['on_site', 'returned'],
  on_site: ['returned'],
  returned: [],
};

export const getResourceKindLabel = (kind) =>
  RESOURCE_KIND_OPTIONS.find((o) => o.value === kind)?.label || kind;

export const getResourceStatusLabel = (status) =>
  RESOURCE_STATUS_OPTIONS.find((o) => o.value === status)?.label || status;

export const getRequirementStatusLabel = (status) =>
  REQUIREMENT_STATUS_OPTIONS.find((o) => o.value === status)?.label || status;

/** Display label of a requirement: resource name or "Categorie × n". */
export const requirementLabel = (req) => {
  const base = req?.resource?.name || req?.resource_name || req?.category || 'Materieel';
  const qty = Number(req?.quantity) || 1;
  return qty > 1 ? `${base} × ${qty}` : base;
};

/** "ma 14 – wo 16 okt" from two YYYY-MM-DD strings. */
export const formatDateRange = (from, to) => {
  if (!from) return '';
  const f = new Date(`${from}T00:00:00`);
  const t = to ? new Date(`${to}T00:00:00`) : f;
  const short = { weekday: 'short', day: 'numeric' };
  const full = { weekday: 'short', day: 'numeric', month: 'short' };
  if (!to || from === to) return f.toLocaleDateString('nl-NL', full);
  const sameMonth = f.getMonth() === t.getMonth();
  return `${f.toLocaleDateString('nl-NL', sameMonth ? short : full)} – ${t.toLocaleDateString('nl-NL', full)}`;
};
